import { HttpMethod, Maybe } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { WORKSPACE_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import { EditMemberRequest, EditMemberResponse } from './types';

export function useDeleteMember(id: Maybe<string>) {
  const workspaceId = useWorkspace()?.id;

  return useBaseMutation<EditMemberRequest, EditMemberResponse>({
    url: `${WORKSPACE_ROOT_ENDPOINT}/${workspaceId}/members/${id}`,
    method: HttpMethod.delete,
  });
}
